//import QuestionTypeRendererExtentions from '../questiontypes/QuestionTypeRendererExtension';
// import '../styles/v3/v3-iframes.css';
// import '../styles/prechat/base_prechat_template.css'
// import '../styles/prechat/prechat_responsive.css'
// import '../styles/prechat/prechat_template.css'
// import '../styles/questiontype.scss'

import preChatPlainTextTemplate from '../templates/invitations/RDPlusTheme/prechat/prechat_plain_text_template.ejs';

import PreChatMessageHandler from './PreChatMessageHandler';
import WidgetTypes from '../core/enums/WidgetTypes';
import WidgetView from '../core/WidgetView';
import TempCache from '../core/enums/TempCache';
import PubSub from '../core/events/PubSub';
import { BaseWidget } from '../core/BaseWidget';;
import SourceType from '../core/enums/SourceTypes';
import BrandingWidget from '../core/enums/BrandingWidget';
import ParticipantIds from '../core/enums/ParticipantIds';
import GlobalVariables from '../core/GlobalVariables';
import cleanInvalidHtml from '../core/hooks/cleanInvalidHtml';
import ChatMode from '../core/hooks/ChatMode';
import PipedMessageHandler from '../core/hooks/PipedMessageHandler';
import addStyleTextInIframe from '../core/hooks/addStyleTextInIframe';
import { Position, PreChatMessageAnimation, PreChatMessageType, ScriptVisitorResponseStatus, ScriptsQuestionType } from '../core/enums/Enum';
import parseTemplate from '../core/hooks/parseTemplate';
import Branding from '../core/hooks/Branding';
import getStyle from '../core/hooks/getStyle';
import removeMultipleCSSClasses from '../core/hooks/removeMultipleCSSClasses';
import encodeHTML from '../core/hooks/encodeHTML';
import decodeHTML from '../core/hooks/decodeHTML';
import removeTextFollowedByColon from '../core/hooks/removeTextFollowedByColon';
import stringify from '../core/hooks/stringify';
import addOptionProperty from '../core/hooks/addOptionProperty';
import AgentImageHandler from '../core/hooks/AgentImageHandler';
import setPrechatStyles from '../core/hooks/setPrechatStyles';
import RunAfter from '../core/hooks/RunAfter';
import Cookies from '../core/hooks/Cookies';
import ChatEvents from '../core/hooks/ChatEvents';
import WidgetStates from '../core/hooks/WidgetStates';
import getCookieValue from '../core/hooks/getCookieValue';
import getStorageAPIValue from '../core/hooks/getStorageAPIValue';
import storageAPIExists from '../core/hooks/storageAPIExists';
import showElement from '../core/hooks/showElement';
import hideElement from '../core/hooks/hideElement';
import removeClass from '../core/hooks/removeClass';
import addClass from '../core/hooks/addClass';
import localstorageAPIExists from '../core/hooks/localstorageAPIExists';
import logIt from '../../logIt';
import localStorageAPIGet from '../core/hooks/localStorageAPIGet';
import importPrechatTemplateFactory from '../core/imports/ImportPrechatTemplateFactory';
import appendGreeting from '../core/hooks/appendGreeting';
import RunAsSoonAsWithDelay from '../core/hooks/RunAsSoonAsWithDelay';
import RunAsSoonAs from '../core/hooks/RunAsSoonAs';
import preChatCloseMessagePopup from './preChatCloseMessagePopup'
import isAutoLaunchChatWindow from '../isAutoLaunchChatWindow';
import isMobile from '../isMobile';


export default class PreChatInvitation extends BaseWidget {
    constructor(options) {
        options.widget = WidgetTypes.PreChat;
        options.styleName = 'prechat'
        super(options);
        this.templateRenderer = null;
        if (!options.preChat) {
            console.log('pre chat not enabled');
            return;
        }
        const me = this;
        me.options = options;

        if (me.options.preChat.chatbotGreetingMessages) {
            var script = structuredClone(me.options.preChat.chatbotGreetingMessages[0]);
            me.options.preChat.chatbotGreetingMessages[0].agentScript = script
            delete me.options.preChat.chatbotGreetingMessages[0].agentScript.agentScript // remove circular properties
            me.options.preChat.chatbotGreetingMessages[0].agentScript.options = JSON.stringify(me.options.preChat.chatbotGreetingMessages[0].agentScript.options)
            me.options.preChat.preChatMessages = me.options.preChat.chatbotGreetingMessages
        }


        me.pipeMessageHandler = new PipedMessageHandler(options);
        me.DEFAULT_PRECHAT_CONFIG = {
            general: { template: 'Simple Style' },
            outerObject: {
                hideOuterObject: false,
                showImage: false,
                backgroundImage: '',
                background1Color: '#5FADD1',
                background2Color: '#5FADD1',
                borderColor: '#FFFFFF',
                borderWidth: '0px',
                borderRadius: '60px',
                padding: '20px 20px 20px 20px'
            },
            innerObject: {
                hideInnerObject: false,
                showImage: true,
                defaultImage: 'chat-icon-simple.png',
                backgroundImage: '',
                background1Color: '',
                background2Color: '',
                borderColor: '#FFFFFF',
                borderWidth: '0px',
                borderRadius: '0px',
                padding: '5px 5px 5px 5px'
            },
            messagePopup: {
                font: {
                    italic: false,
                    bold: false,
                    underline: false,
                    family: 'inherit',
                    size: '18px',
                    color: '#202024'
                },
                backgroundColor: '#feffe0',
                padding: '11.2px 11.2px 11.2px 11.2px',
                borderColor: '#e5e6c8',
                closeIcon: '/contents/themes/skinnable/invitation/close.png',
                closeIconSize: { width: '12px', height: '12px' },
                shadowDepth: '0px',
                borderRadius: '6px',
                borderWidth: '1px'
            },
            messageCounter: {
                font: {
                    italic: false,
                    bold: false,
                    underline: false,
                    family: 'inherit',
                    size: '10px',
                    color: '#FFFFFF'
                },
                backgroundColor: '#823710',
                counterTop: '7px',
                counterRight: '3px'
            }
        };
        const TemplateRenderer = function () {
            const self = this;
            self.heightPosition = 20;
            self.notificationContainer = 'apexchat_prechat_typing_div';
            self.typingIndicator = 'apexchat_rd_prechat_invitation_typing_dots';
            self.showAgentName = function () {
                // no need to implement this function for default templetes
            };
            self.animateMessagePopup = function (el, position) {
                removeClass(el, 'apexchat_prechat_show_message_fade_out');
                addClass(el, 'apexchat_prechat_show_message_fade_in');
            };
            self.showTypingIndicator = function () {
                const containerElement = me.DOM.getElementById(self.notificationContainer);
                if (containerElement) {
                    showElement(containerElement);
                }
            };
            self.hideTypingIndicator = function () {
                const containerElement = me.DOM.getElementById(self.notificationContainer);
                if (containerElement) {
                    hideElement(containerElement);
                }
            };
            self.displayMessageCounter = function () {
                const messageCounter = me.getMessageCounterCache();
                me.DOM.getElementById('apexchat_prechat_message_count').innerHTML = messageCounter;
                me.DOM.getElementById('apexchat_prechat_message_count').style.display = 'flex';
                if (messageCounter === 0) {
                    self.hideMessageCounter();
                }
            };
            self.hideTalkBubbleIcon = function () {
                // no need to implement this function for default templetes
            };
            self.hideMessagePopup = function () {
                // me.DOM.getElementById('apexchat_prechat_message_popup').style.display = 'none';
                removeMultipleCSSClasses(
                    me.DOM.getElementById('apexchat_prechat_message_popup'),
                    'prechat_zoom_in_animation_left prechat_zoom_in_animation_right'
                );
                removeMultipleCSSClasses(
                    me.DOM.getElementById('apexchat_prechat_typing_div'),
                    'prechat_zoom_in_animation_left prechat_zoom_in_animation_right'
                );
                const roundedMessagePopup =
                    me.DOM.getElementsByClassName('apexchat_prechat_message_bubble')
                // me.$(me.DOM.getElementById('apexchat_prechat_message_popup_container'))
                // .find('.apexchat_prechat_message_bubble');
                if (roundedMessagePopup.length > 0) {
                    hideElement(roundedMessagePopup[roundedMessagePopup.length - 1]);
                } else {
                    addClass(
                        me.DOM.getElementById('apexchat_prechat_message_popup'),
                        'apexchat_prechat_show_message_fade_out'
                    );
                }
                me.displayMessageCounter();
                me.DOM.getElementById('apexchat_prechat_message').classList.remove("livechat_prechat_first_message");
                // resize iframe
                // me.postMessage({ event: 'prechat-size', data: { width: me.iconWidth, height: me.iconHeight } });
            };
            self.hideMessageCounter = function () {
                me.DOM.getElementById('apexchat_prechat_message_count').style.display = 'none';
            };
            self.widgetWidth = 295;
            self.renderOnLeftPosition = function () {
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup'),
                    'apexchat_prechat_tri_left apexchat_prechat_left_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_container'),
                    'apexchat_prechat_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_bg'),
                    'apexchat_prechat_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_close_message_popup'),
                    'apexchat_prechat_x_right'
                );
                // Mobile responsive
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup'),
                    'apexchat_prechat_talk_bubbleMsg_left'
                );
            };
            self.renderOnRightPosition = function () {
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup'),
                    'apexchat_prechat_tri_right apexchat_prechat_right_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_bg'),
                    'apexchat_prechat_right'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_container'),
                    'apexchat_prechat_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_bg'),
                    'apexchat_prechat_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_close_message_popup'),
                    'apexchat_prechat_x_left'
                );
                // Mobile responsive
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup'),
                    'apexchat_prechat_talk_bubbleMsg_right'
                );
            };
            self.showOnlineAgentTag = function () {
                const agentName = me.DOM.getElementsByClassName('online-agent-tag');
                agentName[0].innerHTML = me.options.preChat.preChatAgentStatusText;
                agentName[0].style.display = 'block';
                // hide online tag and glow invitation aftr 45 seconds
                setTimeout(() => {
                    // hide tag
                    addClass(
                        me.DOM.getElementById('apexchat_prechat_chat_icon'),
                        'glow_pre_chat_icon'
                    );
                }, 45000);
            };
            self.popupUI = function () {
                const _render = function (message) {
                    if (!message.message && message.text) {
                        message.message = message.text;
                    }
                    me.DOM.getElementById('apexchat_prechat_message').innerHTML = message.message;
                    me.DOM.getElementById('apexchat_prechat_message_popup_container').classList.add('livechat_prechat_message_show');
                };
                const _clearContent = function () {
                    me.DOM.getElementById('apexchat_prechat_message').innerHTML = '';
                };
                const _doNothing = function () {
                    // do nothing..
                };
                const _questionTypeUIConfiguration = function (questionType) {
                    me.setAllowBackgroundClick(questionType);
                    me.$('.apexchat_question_type_close_button', me.DOM).attr(
                        'style',
                        'display:none !important'
                    );
                    me.$('#apexchat_click_instruction', me.DOM).attr(
                        'style',
                        'display: none !important'
                    );
                    me.DOM.querySelector('#apexchat_participant_display_name').setAttribute(
                        'style',
                        'display: none !important'
                    );
                    me.$('#apexchat_participant_display_col', me.DOM).attr(
                        'style',
                        'display: none !important'
                    );
                };
                return {
                    render: _render,
                    clear: _clearContent,
                    setMessageTemplate: _doNothing,
                    questionTypeUIConfiguration: _questionTypeUIConfiguration
                };
            };
        };
        const RoundedTemplateRenderer = function (renderer, heightPosition) {
            const self = this;
            self.agentNameImageId = 'agent_name_prechat_rounded_theme';
            self.heightPosition = heightPosition;
            self.renderer = renderer;
            self.animateMessagePopup = function (el, position) { };
            self.showAgentName = function () {
                // me.$(`#${self.agentNameImageId}`, me.DOM).html(me.options.agentName);
                me.DOM.getElementById(self.agentNameImageId)?.innerHTML = me.options.agentName;
            };
            self.showTypingIndicatorInnerGlider = function () {
                me.DOM.getElementsByClassName(self.renderer.typingIndicator)[0].style.display =
                    'inline-block';
                const elem = me.DOM.getElementsByClassName(renderer.typingIndicator);
                for (let i = 0; i < elem.length; i++) {
                    elem[i].style.display = 'inline-block';
                }
            };
            self.hideMessagePopup = function () {
                self.renderer.hideMessagePopup();
            };
            self.showTypingIndicator = function () {
                const containerElement = me.DOM.getElementById(renderer.notificationContainer);
                if (containerElement) {
                    showElement(containerElement);
                    self.showTypingIndicatorInnerGlider();
                    me.DOM.getElementById('apexchat_prechat_message_count').style.display = 'none';
                    containerElement.classList.remove('disabled');
                    //me.$(containerElement, me.context).removeClass('disabled');
                }
            };
            self.widgetWidth = 98;
            self.hideTypingIndicatorInnerGlider = function () {
                me.DOM.getElementsByClassName(self.renderer.typingIndicator)[0].style.display =
                    'none';
                const elem = me.DOM.getElementsByClassName(renderer.typingIndicator);
                for (let i = 0; i < elem.length; i++) {
                    hideElement(elem[i]);
                }
            };
            self.hideTypingIndicator = function () {
                // self.hideTypingIndicatorInnerGlider();
                const messageCounter = me.getMessageCounterCache();
                if (messageCounter > 0) {
                    self.displayMessageCounter();
                    return;
                }
                const containerElement = me.DOM.getElementById(renderer.notificationContainer);
                if (containerElement) {
                    // hideElement(containerElement);
                    //me.$(containerElement, me.context).addClass('disabled');
                    containerElement.classList.add('disabled')
                }
            };
            self.displayMessageCounter = function () {
                const messageCounter = me.getMessageCounterCache();
                if (messageCounter > 0) {
                    me.DOM.getElementById('apexchat_prechat_message_count').innerHTML =
                        messageCounter;
                    me.DOM.getElementById('apexchat_prechat_typing_div').style.display = 'flex';
                    me.DOM.getElementById('apexchat_prechat_message_count').style.display = 'flex';
                    self.hideTypingIndicatorInnerGlider();
                } else {
                    self.hideMessageCounter();
                    self.hideTalkBubbleIcon();
                }
                //me.$('#apexchat_prechat_typing_div', me.DOM).removeClass('disabled');
                me.DOM.getElementById('apexchat_prechat_typing_div').classList.remove('disabled');
            };
            self.hideMessageCounter = function () {
                me.DOM.getElementById('apexchat_prechat_message_count').style.display = 'none'
                //me.$('#apexchat_prechat_message_count', me.DOM).hide();
            };
            self.hideTalkBubbleIcon = function () {
                //me.$('#apexchat_prechat_typing_div', me.DOM).hide();
                me.DOM.getElementById('apexchat_prechat_typing_div').style.display = 'none'
            };
            self.renderOnLeftPosition = function () {
                renderer.renderOnLeftPosition();
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup_container'),
                    'apexchat_prechat_rounded_theme_left'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_typing_div'),
                    'talk_bubble_left'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_container'),
                    'apexchat_prechat_left'
                );
                removeClass(
                    me.DOM.getElementById('apexchat_prechat_typing_div'),
                    'talk_bubble_right'
                );
            };
            self.renderOnRightPosition = function () {
                renderer.renderOnRightPosition();
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup_container'),
                    'apexchat_prechat_rounded_theme_right'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_typing_div'),
                    'talk_bubble_right'
                );
                removeClass(
                    me.DOM.getElementById('apexchat_prechat_typing_div'),
                    'talk_bubble_left'
                );
            };
            self.popupUI = function (isPreChatRoundedTheme) {
                const _container = me.DOM.getElementById('apexchat_prechat_message');// me.$('#apexchat_prechat_message', me.DOM);
                const _setMessageTemplate = function () {
                    if (!isPreChatRoundedTheme) {
                        return;
                    }
                    if (!ApexChat.preChatMsgTemplate) {
                        // we need to replace Close button according to animationType
                        switch (me.options.preChatMessageAnimation) {
                            case PreChatMessageAnimation.Default:
                            case PreChatMessageAnimation.Stacking:
                                _hideCloseButton();
                                break;
                            case PreChatMessageAnimation.MobileStacking:
                                _hideCloseCrossSymbol();
                                break;
                        }
                        // const message = document.createTextNode('##message##'); // Create a text node
                        // me.DOM.getElementById('apexchat_prechat_message').innerHTML = message;
                        me.DOM.getElementById('apexchat_prechat_message').innerHTML = preChatPlainTextTemplate({
                            text: '##message##',
                            hidden: true
                        });
                        me.DOM.getElementById('apexchat_prechat_message_popup_container').classList.add('livechat_prechat_message_show');

                        //me.$('#apexchat_prechat_message', me.DOM).html(message);

                        const participants = ApexChat.localStorageAPI.Get(
                            'livechat_chat_participants'
                        );
                        let participantInfo = JSON.parse(participants || '{}');
                        participantInfo = participantInfo[participantInfo.length - 1];
                        // if participants found then we need to update the image and agent name of the next pre-chat pop-up message
                        if (
                            participants &&
                            participantInfo &&
                            participantInfo.userId !== ParticipantIds.visitor
                        ) {
                            // Dont run for visitor case
                            if (participantInfo.handlerImageUrl) {
                                // me.$(
                                //     '.agent_image_prechat_rounded_theme .apexchat_prechat_chat_icon',
                                //     me.DOM
                                // ).css(
                                //     'background-image',
                                //     `url(${participantInfo.handlerImageUrl})`
                                // );
                                me.DOM.querySelector('.apexchat_prechat_chat_icon')?.style.backgroundImage =
                                    `url(${AgentImageHandler(participantInfo.handlerImageUrl)})`
                            }
                            me.DOM.querySelector('.agent_name_prechat_rounded_theme')?.innerHTML = participantInfo.displayName
                        } else {
                            me.DOM.querySelector('.agent_name_prechat_rounded_theme')?.innerHTML = me.options.agentName
                        }
                        ApexChat.preChatMsgTemplate = '<div>' + me.DOM.querySelector('#apexchat_prechat_message_popup').cloneNode(true).innerHTML + '</div>';
                        me.DOM.getElementById('apexchat_prechat_message_popup_container').classList.add('apexchat_prechat_default_animation')
                        ApexChat.sessionAPI.Store(
                            'livechat_prechat_msg_template',
                            ApexChat.preChatMsgTemplate
                        );
                        me.messenger.setMessageTemplate(ApexChat.preChatMsgTemplate);
                    }
                };
                var _hideCloseButton = function () {
                    me.DOM.getElementById('apexchat_prechat_rd_close_btn_icon').style.display = 'none';
                };
                var _hideCloseCrossSymbol = function () {
                    me.DOM.getElementById('apexchat_prechat_close_message_popup').style.display = 'none';
                    me.DOM.getElementById('apexchat_prechat_rd_close_btn_icon').style.display = 'block';

                };
                const _push = function (message) {
                    if (!isPreChatRoundedTheme) {
                        return;
                    }
                    if (!message.message && message.text) {
                        message.message = message.text;
                    }
                    message.message = decodeHTML(
                        cleanInvalidHtml(
                            removeTextFollowedByColon(message.message)
                        )
                    );
                    //  message.message = removeTextFollowedByColon(message.message);
                    // on this switch we will take decision.
                    switch (me.options.preChatMessageAnimation) {
                        case PreChatMessageAnimation.Default:
                            _renderDefault(message);
                            break;
                        case PreChatMessageAnimation.Stacking:
                        case PreChatMessageAnimation.MobileStacking:
                            _renderStacking(message);
                            break;
                    }
                    // check chatMsg variable is exists and ApexChat.preChatElement is not undefined livechat_participant_display_text
                    if (message.questionType == ScriptsQuestionType.None) {
                        _setTabIndex();
                    } else {
                        _removeTabIndex();
                    }
                };
                var _setTabIndex = function () {
                    _container.setAttribute('tabindex', 0);
                };
                var _removeTabIndex = function () {
                    _container.setAttribute('tabindex', -1);
                };
                var _renderDefault = function (message) {
                    // IFrame resizing on Clicking Action of QuestionType
                    me.postMessage({
                        // no need to send 0 currentMsgHeight
                        event: 'prechat-auto-resizing',
                        data: {
                            isSingleMsg: true
                        }
                    });
                    if (!message.dontAppendExisitngContent && message?.message) {
                        // me.$('#apexchat_prechat_message', me.DOM).html(message.message);
                        me.DOM.getElementById('apexchat_prechat_message').innerHTML = preChatPlainTextTemplate({
                            text: message.message,
                            hidden: false
                        });
                        const questionWrapper = me.DOM.querySelector('.livechat_prechat_plain_text_greet');
                        appendGreeting(questionWrapper, me.options);
                        me.DOM.getElementById('apexchat_prechat_message_popup_container').classList.add('livechat_prechat_message_show');

                    } else {
                        me.DOM.getElementById('apexchat_prechat_message').innerHTML = ''
                    }

                    // we are showing with opacity 0; because we cant calculate dynamic height differences If element is Hidden,
                    // Initially, we were adding CSS Class for making Opacity 0 & 1 but adding and removing class was making a jerk we needed the animation effect between 0 to 1, in decimal manner like 0.1, 0.2, 0.3... to 0.9, 1
                    //me.$('#apexchat_prechat_message_popup', me.DOM).show().css({ opacity: 0 });
                    const ele = me.DOM.getElementById('apexchat_prechat_message_popup');
                    ele.style.display = 'block';
                    ele.style.opacity = 0;
                    // we need this timeout as DOM takes time to render, without timeout.
                    // ApexChat.getStyle giving wrong values without timeout.
                };
                var _renderStacking = function (message) {
                    me.messenger.push(message);
                };
                const _doNothing = function () { };
                const _questionTypeUIConfiguration = function (questionType) {
                    me.setAllowBackgroundClick(questionType);
                    me.DOM.querySelector('.apexchat_question_type_close_button')?.style.setProperty('display', 'none', 'important');
                    me.DOM.querySelector('.apexchat_participant_display_text#apexchat_participant_display_name')?.style.setProperty('display', 'none', 'important');
                    me.DOM.querySelector('.apexchat_participant_display_text#apexchat_participant_display_col')?.style.setProperty('display', 'none', 'important');
                    console.log('Rounded Template renderer _questionTypeUIConfiguration');
                };
                return {
                    setMessageTemplate: _setMessageTemplate,
                    render: _push,
                    clear: _doNothing,
                    questionTypeUIConfiguration: _questionTypeUIConfiguration
                };
            };
        };
        let renderer = new TemplateRenderer();
        if (me.options.preChat.preChatThemeSetting) {
            if (
                JSON.parse(options.preChat.preChatThemeSetting).general.template === GlobalVariables.preChatRoundedThemeName
            ) {
                me.options.isPreChatRoundedTheme = true;
                renderer = new RoundedTemplateRenderer(renderer, 130);
            }
        }

        me.templateRenderer = renderer;

        if (me.options.chatMode == ChatMode.Windowed) {
            this.mode = WidgetTypes.Windowed;
        } else if (me.options.chatMode == ChatMode.DOM) {
            this.mode = WidgetTypes.DOM;
        }
        this.lastMessageStoreName = 'livechat_prechat_lastmessage';
        this.messageCounterStoreName = 'livechat_prechat_messagecounter';
        // super(
        //     Object.assign(me.options, {
        //         widget: WidgetTypes.PreChat
        //     })
        // );

        const handlePrechatVisibility = (data = {}) => {
            if (me.options && me.options.videoGreetEnabled) {
                data.show ? me.show() : me.hide();
            }
        }
        this.subscribe(WidgetTypes.VideoGreetInvitation + WidgetStates.ShownMaximized, handlePrechatVisibility);
        this.subscribe(WidgetTypes.VideoGreetInvitation + WidgetStates.Refreshed, handlePrechatVisibility);
        this.subscribe('videogreet-init', () => {
            const lastVGState = me.state.getStateValue(WidgetTypes.VideoGreetInvitation); // get video greet state
            me.isVideoGreet = true;
            if (lastVGState != WidgetStates.Hidden) {
                // check video greet maximize
                me.isVideoGreetMax = true;
            }
        });
        if (me.isPageRefreshed()) {
            me.ready();
            if (me.options && me.options.videoGreetEnabled) {
                me.postMessage({
                    event: 'videogreet-gif-file-loaded',
                    data: {
                        imageUrl: me.options.videoGreet.animatedImageUrl
                    }
                });
            }
        } else {
            const preChatDuration =
                me.options && me.options.videoGreetEnabled
                    ? 1000
                    : me.options.preChat.preChatLoadTimeout * 1000;
            //setTimeout(() => {
            me.ready();
            //}, preChatDuration);
        }
        me.messageArray = [];
    }

    ready() {
        super.ready();
        const me = this;
        me.create();
        me.templateRenderer.hideTypingIndicator();
        me.subscribe('new-pre-chat-message-arriving', (args) => {
            me.templateRenderer.showTypingIndicator();
        });
        me.subscribe(WidgetTypes.DOM + WidgetStates.ShownMinimized, (args) => {
            me.templateRenderer.hideTypingIndicator();
        });
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnChatJoined, (args) => {
            // CHAT-6280-Handle PreChat hits, subscribed onChatJoined method from chatroom-v3.js
        });
        me.subscribe('videogreet-gif-file-loaded', (data) => {
            if (data.imageUrl) {
                const image = me.DOM.getElementById('apexchat_prechat_chat_icon');
                image.classList.add('video_greet_animated_gif');
                image.style.backgroundImage = `url('${data.imageUrl}')`;
            }
        });
        me.subscribe(WidgetTypes.DOM + WidgetStates.ShownMinimized, (args) => {
            me.templateRenderer.hideTypingIndicator();
        });
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnChatJoined, (args) => {
            // CHAT-6280-Handle PreChat hits, subscribed onChatJoined method from chatroom-v3.js
        });

        /* messenger is taking instance of PreChatMessageHandler with few important arguments
         * */
        me.messenger = new PreChatMessageHandler( // encapsulated message handler for PreChat
            Object.assign(me.options, {
                context: me.DOM,
                prechatTemplate: importPrechatTemplateFactory(me.options)?.prechatTemplate,
                // prechatTemplate: preChatTemplate({

                // }),
                prechatModel: me.options.preChat
            })
        );
    }

    create() {
        super.create();
        const me = this;
        me.view = new WidgetView({
            dom: this.DOM,
            identifier: WidgetTypes.PreChat,
            templates: [
                {
                    key: WidgetStates.ShownMaximized,
                    // tpl: preChatTemplate({
                    //     title: 'My Webpage',
                    // }),
                    tpl: importPrechatTemplateFactory({
                        title: 'My Webpage',
                    })?.prechatTemplate,
                    model: me.options.preChat,
                    async afterRender(tpl) {
                        me.messagesContainer = me.DOM.getElementById('apexchat_prechat_message');

                        me.templateRenderer.showAgentName();
                        const handleQuestionTypeResponse = async (res) => {
                            const module = await import(/* webpackChunkName: "handlePrechatQuestionType" */ './handlePrechatQuestionType')
                            const handlePrechatQuestionType = module.default;
                            handlePrechatQuestionType(me, res.res || res);
                        };
                        if (!me.QTRendererExt) {
                            const module = await import(/* webpackChunkName: "questionTypeRendererExtension" */ '../questiontypes/QuestionTypeRendererExtension')
                            const QuestionTypeRendererExtentions = module.default;
                            me.QTRendererExt = new QuestionTypeRendererExtentions();
                            await me.QTRendererExt.initComponent(
                                Object.assign(me.options.preChat, {
                                    isUpdateSupported: false,
                                    context: me.DOM,
                                    messagesContainer: me.messagesContainer,
                                    responseCallback: handleQuestionTypeResponse,
                                    enableFullTextLogic: true,
                                    widgetType: WidgetTypes.PreChat,
                                    countryCode: me.options.countryCode,
                                    prechatResizeHandler: me.showMessagePopupAndPublishAutoResize.bind(me),
                                })
                            );
                        }

                        const isPreChatMaximized =
                            me.state.getStateValue(WidgetTypes.PreChat) ===
                            WidgetStates.ShownMaximized;
                        // JIRA_7493 & 7477 ChatId Null issue
                        me.options.chatId = me.options.chatId || me.getChatId();
                        if (
                            me.isChatActive() &&
                            me.isPageRefreshed() &&
                            isPreChatMaximized &&
                            me.options.chatId
                        ) {
                            import(/* webpackChunkName: "liveChatRoom" */ '../core/LiveChatRoom').then((module) => {
                                const LiveChatRoom = module.default;
                                // Creating ChatRoom object for sending the prechat Agent Script's replies to dashboard via websync.
                                me.prechatRoom = new LiveChatRoom(
                                    Object.assign(me.options, me.options.model)
                                );

                                // We don't need to subscribe this channel if exit-popup is in maximize state and user refresh the page,
                                // if we do that the last message of the user will show as a duplicate message on exit-popup
                                me.prechatRoom.subscribeToChatChannel(me.options.chatId);
                                let participants = ApexChat.localStorageAPI.Get(
                                    'livechat_chat_participants'
                                );
                                if (participants) {
                                    participants = JSON.parse(participants);
                                    me.onParticipantsChanged(participants);
                                }
                            });
                        }
                        // pasre/apply pre chat theme setting
                        me.skin = JSON.parse(me.options.preChat.preChatThemeSetting);
                        if (!me.skin) {
                            me.skin = me.DEFAULT_PRECHAT_CONFIG;
                        }
                        me.handleADA(
                            me.DOM.querySelector('#apexchat_prechat_close_message_popup'),
                            async (e) => {
                                e.stopPropagation();
                                preChatCloseMessagePopup(me, e);
                            }
                        );
                        me.handleADA(
                            me.DOM.querySelector('#apexchat_prechat_rd_close_btn_icon'),
                            async (e) => {
                                e.stopPropagation();
                                preChatCloseMessagePopup(me, e);
                            }
                        );
                        // me.handleADA(
                        //     me.$('#apexchat_prechat_rd_close_btn_icon', me.DOM)[0],
                        //     (e) => {
                        //         me.closeMessagePopup(e);
                        //     }
                        // );


                        me.options.handlerImageUrl = AgentImageHandler(me.options.handlerImageUrl)

                        // if the user name has a space then we need to enclose the image URL in single quote.
                        me.skin.handlerImageUrl = `${AgentImageHandler(me.options.handlerImageUrl)}`;
                        const rdThemeSettings =
                            me.options && me.options.rdThemeSettings
                                ? ApexChat.TryParse(me.options.rdThemeSettings)
                                : null;
                        let skinJson = {
                            container: '',
                            preChat: me.skin
                        };
                        skinJson.rdThemeSettings = rdThemeSettings;
                        /* Branding - PreChat */
                        const brandingInfo = skinJson.rdThemeSettings.branding || {};
                        if (brandingInfo.brandingIsEnabled) {
                            var branding = new Branding()
                            skinJson.global = { branding: brandingInfo };
                            branding.init({
                                widget: BrandingWidget.RD_PreChat,
                                brandConfig: skinJson
                            })
                            skinJson = branding.getBrandedConfig();
                        }
                        setPrechatStyles(me.DOM, skinJson);
                        addStyleTextInIframe(
                            me.options.invitationWidgetStyleCustom,
                            'apexchat_custom_fontAwesome',
                            undefined,
                            me.DOM
                        );

                        // // set UI configuration
                        // Utils.fontsLoaded({
                        //     fontName: 'Avenir',
                        //     context: me.DOM,
                        //     window: me.iFrameWindow,
                        //     onSuccess() {
                        //         me.UIConfiguration();
                        //     }
                        // });

                        me.UIConfiguration().then(() => {
                            if (me.DOM && me.DOM.getElementById('apexchat_prechat_chat_icon')) {
                                let backgroundImage = getStyle(
                                    me.DOM.getElementById('apexchat_prechat_chat_icon'),
                                    'background-image'
                                );
                                if (backgroundImage && backgroundImage.indexOf('.png') === -1) {
                                    me.DOM.querySelector('#apexchat_prechat_main_bg').classList.add(
                                        'apexchat_css_background_transparent'
                                    );
                                }
                            }
                            if (isAutoLaunchChatWindow(me.options) && !ApexChat.localStorageAPI.Get(TempCache.DOM_Auto_Launched)) {
                                RunAsSoonAsWithDelay(() => {
                                    me.startChatFromPreChat();
                                }, () => !ApexChat.isProcessingPipedMessage, 3000);
                            }

                        });
                        //await me.UIConfiguration();


                        // hideElement(
                        //     me.DOM.getElementById('apexchat_prechat_message_popup')
                        // ); // Hide the initial popup

                        // CHAT_8288 - Remove white background for all image extension and added for .png only

                    }
                }
            ],
            initialState: WidgetStates.ShownMaximized
        });
    }

    postPreChatMessages(res) {
        const me = this;
        // We need to prevent multiple posting of same ChatLogID, created an array and saving the chatlogId
        me.postedPreChatMessagesArray = me.postedPreChatMessagesArray || [];
        // if the chatlogId is already being posted, preventing it to repost which was making text appear twice in dashboard
        if (
            res.chatLogId &&
            me.postedPreChatMessagesArray.indexOf(res.chatLogId) !== -1 &&
            !(res.questionType != ScriptsQuestionType.Text)
        ) {
            return false;
        }
        // saving chatlogId is array
        // check checklogid exists or not
        if (res.chatLogId && me.postedPreChatMessagesArray.indexOf(res.chatLogId) !== -1) {
            me.postedPreChatMessagesArray.push(res.chatLogId);
        }
        me.postMessage({
            event: WidgetTypes.PreChat + WidgetStates.MessageSent,
            data: res
        });

        const pubSub = new PubSub();
        const domRendered = pubSub.allSubscriptions()[WidgetTypes.DOMUIController]; // DOM has not opened?
        // We only need to send the PreChat Agent Script's replies to dashboard via 'prechatRoom' object until DOM appeared.
        me.startChatFromPreChat(); /* <--CHAT-6961 - Open Chat window, no need to continue mapping on prechat */
        if (!domRendered) {
            me.prechatRoom.setWebSyncClient();
            me.prechatRoom.publishQuestionTypeResponse(res);
            // Set the visitor selection of question type
            res.visitorSelectedOptions = res.answers;
            res.questionType = me.QTRendererExt.questionTypeRenderer.renderer.model.questionType;
            res.questionTypeDisplayListForVisitor =
                me.QTRendererExt.questionTypeRenderer.renderer.model.questionTypeDisplayListForVisitor;
            res.id = res.chatLogId;

            res.visitorScriptAnswer = res.answers;
            res.visitorResponseStatus = res.isSkipped
                ? ScriptVisitorResponseStatus.Skipped
                : ScriptVisitorResponseStatus.Answered;
            me.QTRendererExt.questionTypeRenderer.setVisitorSelection(res);
            me.prechatRoom.sendMessage({
                chatMsg: res.msgText,
                questionTypeChatLogIdToBeUpdated: res.questionTypeChatLogIdToBeUpdated
            });
        }
    }

    isChatAlreadyStartedFromPreChat() {
        // ref. CHAT-4589
        const lastDOMState = this.state.getStateValue(WidgetTypes.DOM);
        const currentPreChatState = this.getCurrentState();
        // the following condition ensures that:
        return (
            this.isChatInProgress() && // 1. Chat was started on PreChat or PreChatMessage Click
            lastDOMState == WidgetStates.ShownMinimized && // 2. Then DOM was minimized
            currentPreChatState == WidgetStates.ShownMaximized
        ); // 3. and PreChat has appeared back in Max/default state
    }

    startChatFromPreChat(e, config) {
        const me = this;

        // is there a srcElement passed and it has a data attribute named shouldStartChat with value = false? return.
        if (
            (config && !config.srcElement) ||
            (config && config.srcElement && !config.srcElement.getAttribute('data-should-start-chat'))
        ) {
            return false;
        }
        // me.postMessage({ event: WidgetTypes.PreChat + WidgetStates.Clicked, data: {} });
        // me.initiatedBy = 'PreChat';
        me.state.changeState({
            toState: WidgetStates.Clicked,
            value: { initiatedBy: 'PreChat' }
        });
        if (me.isWindowedStarted() || me.options.chatMode == ChatMode.Windowed) {
            me.options.chatInitiatedBy = 'PreChat';
            me.startWindowedChat(
                Object.assign(me.options, {
                    shouldContinueMapping: ApexChat.shouldContinueMapping,
                    FullTextVisitorResponse: ApexChat.FullTextVisitorResponse
                })
            ); // pass parameter as a querystring
        }
        me.closePreChatUI();
    }

    closePreChatUI() {
        const me = this;
        ApexChat.preChatElement = null;
        // when closing prechat msg IFrame should resize.
        me.postMessage({
            event: 'prechat-auto-resizing',
            data: {
                isResetIframe: true,
                isSingleMsg: true,
                hideCloseButton: true // we need to hide close button
            }
        });
    }

    async UIConfiguration() {
        const me = this;
        const position = me.options.preChat.preChatPosition;
        // get width/height of prechat object without popup message
        const el = me.DOM.getElementById('apexchat_prechat_chat_icon');
        if (el) {
            me.iconWidth = (el.offsetWidth ? el.offsetWidth : 80) + 30;
            me.iconHeight =
                (el.offsetHeight ? el.offsetHeight : 80) +
                (me.skin.outerObject.hideOuterObject ? 0 : 20);
            ApexChat.PreChatIconDimensions = {
                Width: me.iconWidth,
                Height: me.iconHeight
            };
        }

        me.templateRenderer.hideMessagePopup();
        // apply css class to prechat object base on position
        me.applyCssClass(position);
        if (!me.isVideoGreetMax) {
            // check video greet maximize
            // notify iframe for resize
            me.postMessage({
                event: 'prechat-size',
                data: {
                    width: me.iconWidth,
                    height: me.iconHeight,
                    onCreateSizing: true,
                    addValue: me.templateRenderer.heightPosition
                }
            });
        }
        if (!me.isChatInProgress()) {
            // ref. CHAT-4589: we should stop pre-chat message popups on susequent page reloads
            if (me.options && !me.options.preChat.disablePrechatPopup) {
                await me.queueAutoMessaging();
            }
        }
        const popupSelector = me.DOM.querySelector('#apexchat_prechat_close_message_popup')
        // bind close button
        if (me.options.isMobile) {
            //me.$(popupSelector, me.DOM).show();
            popupSelector.style.display = 'block';
        }
        popupSelector.addEventListener('click', async (e) => {
            e.stopPropagation();
            preChatCloseMessagePopup(me, e);
        })
        me.DOM.querySelector('#apexchat_prechat_rd_close_btn_icon').addEventListener('click', async (e) => {
            e.stopPropagation();
            preChatCloseMessagePopup(me, e);
        });
        //binding event on DOM because elements are not generated the time when this code runs
        me.DOM.addEventListener('click', function (e) {
            if (e.target.closest('.apexchat_mc_ata_list') || e.target.closest('.live_chat_scheduler_bg')) {
                me.startChatFromPreChat(); // click on option DOM window open
            }
            // me.DOM.getElementById('apexchat_prechat_message').classList.remove("livechat_prechat_first_message");
        });
        me.eventSubscription();
        // get icon object for start chat event binding default use inner object but if inner object is hide then use outer object
        let startChatDiv = 'apexchat_prechat_chat_icon';
        if (me.skin.innerObject.hideInnerObject) {
            startChatDiv = 'apexchat_prechat_main_bg';
        }
        this.options.containerId = startChatDiv;

        me.setClickCallToAction(startChatDiv, 'PreChat', {
            shouldContinueMapping: ApexChat.shouldContinueMapping,
            FullTextVisitorResponse: ApexChat.FullTextVisitorResponse
        }); // pass parameter to send via query string

        const domState = me.state.getStateValue(WidgetTypes.DOM);
        const videoGreetState = me.state.getStateValue(WidgetTypes.VideoGreetInvitation);
        const isChatActive = me.isChatActive();
        const isMinimizedOrClosed =
            domState === WidgetStates.ShownMinimized || domState === WidgetStates.Closed;
        const isHidden = me.getCurrentState() === WidgetStates.Hidden;
        const isMaximized = domState === WidgetStates.ShownMaximized;
        const isVideoGreetMax = videoGreetState == WidgetStates.ShownMaximized
        // 1. If video greet is enabled, always hide prechat when chat active and not minimized
        if (me.options?.videoGreetEnabled && !isMinimizedOrClosed && isChatActive) {
            me.hide();
            return;
        }

        // 2. Show prechat when widget is minimized/closed and chat is inactive
        if (isMinimizedOrClosed && !isChatActive) {
            me.show();
            return;
        }

        // 3. Hide prechat when chat is active but widget hidden,
        // or when video greet is enabled but state is undefined
        if ((isHidden && isChatActive) || (me.options?.videoGreetEnabled && videoGreetState === undefined)) {
            me.hide();
            return;
        }

        // 4. When chat already started and widget maximized, reset and hide
        if (isMaximized) {
            me.resetMessageCounterCache();
            me.options.preChat.preChatMessages = [];
            me.hide();
            return;
        }

        // 5. Default: show prechat
        if (isVideoGreetMax) {
            me.hide();
            return;
        }

        // 6. Show prechat
        me.show();

    }
    eventSubscription() {
        const me = this;
        const hideIt = function () {
            me.isChatStartedFromPreChat = true; // CHAT-7681 Iphone prechat double greeting Issue
            if (me.options.chatMode == ChatMode.DOM) {
                // do not hide for iphone.
                // in case of hiding, the dom is not reading some defined values
                // CHAT-6151
                if (me.options.isMobile && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
                    // reset message counter
                    // this is a hack for the release
                    // mahad will come up with better solution for this later.
                    me.pipeMessageHandler.reset(); // stop all processing of pipe messages if its running for iphone
                    me.resetMessageCounterCache();
                    me.templateRenderer.hideMessagePopup();
                    me.hide();
                    return;
                }
                me.hide();
                me.closePreChatUI(); // CHAT-7155 - Closing PreChat UI When opening DOM for context resolving issues.
            } else {
                window.clearTimeout(me.messageTimeout);
                me.resetMessageCounterCache();
                me.templateRenderer.hideMessagePopup();
            }
        };
        const chatStartedFromExitPopup = function () {
            me.hide();
        };
        const chatStartedFromPrechat = function () {
            me.isChatStartedFromPreChat = true; // CHAT-7681 Iphone prechat double greeting Issue
            // CHAT-6794 // need to remove the last stored mapped question because another parent question has appeared.
            ApexChat.storageAPI.Remove(TempCache.APEXCHAT_PRECHAT_MAPPED_QUESTION_COOKIE);
            // Show Windowed Widget instead DOM, when Windowed chat already started
            if (me.options.chatMode === ChatMode.DOM) {
                me.closePreChatUI();
                hideIt();
            }
        };
        const cleanUp = function () {
            // JIRA_6472 - Greeting was not appearing on reinitializing
            // summary: Removing the PreChat Message Sent helped the greeting to appear it again.
            ApexChat.storageAPI.Remove(TempCache.PreChat_Message_Sent);
        };
        const showIt = function () {
            const domState = me.state.getStateValue(WidgetTypes.DOM);
            if (domState == WidgetStates.ShownMaximized) {
                return;
            }
            me.show();
        };
        // subscribe for chat Message and typing indicator when chat mode has set to dom
        if (me.options.chatMode == ChatMode.DOM) {
            me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnMessageArrived, (args) => {
                if (
                    me.state.getStateValue(WidgetTypes.PreChat) ===
                    WidgetStates.ShownMaximized &&
                    me.options.preChatMessageAnimation !== PreChatMessageAnimation.Default
                ) {
                    // specifically for Stacking and Mobile Stacking Animation, we dont need runAfter for that animation
                    me.onMessageArrived(args.m, args.initialLoad, args.index); // BUG-CHAT-7457 Minimize PreChat for Stacking not working properly
                } else {
                    RunAfter(
                        () => {
                            me.onMessageArrived(args.m, args.initialLoad, args.index);
                        },
                        me.state.getStateValue(WidgetTypes.PreChat) ===
                            WidgetStates.ShownMaximized
                            ? 0
                            : 1000
                    );
                }
            });
            me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnTypingArrived, (args) => {
                me.onTypingArrived(args);
            });

            me.subscribe(WidgetTypes.DOM + WidgetStates.Closed, showIt);
            me.subscribe(WidgetTypes.DOM + WidgetStates.ShownMinimized, showIt);
        }
        // subscribe for start chat event from any invitation
        me.subscribe(
            WidgetTypes.ExitPopup + WidgetStates.ShownMaximized,
            chatStartedFromExitPopup
        );
        me.subscribe(WidgetTypes.ExitPopup + WidgetStates.Closed, showIt);
        me.subscribe(WidgetTypes.DropDown + WidgetStates.Clicked, hideIt);
        me.subscribe(WidgetTypes.Bar + WidgetStates.Clicked, hideIt);
        me.subscribe(WidgetTypes.Tab + WidgetStates.Clicked, hideIt);
        me.subscribe(WidgetTypes.PreChat + WidgetStates.Clicked, chatStartedFromPrechat);
        me.subscribe(
            WidgetTypes.ChatRoom + ChatEvents.OnParticipantsChanged,
            (participants) => {
                me.onParticipantsChanged(participants);
            }
        );
        me.subscribe(WidgetTypes.VideoGreetInvitation + WidgetStates.Closed, async () => {
            me.postMessage({
                event: 'videogreet-gif-file-loaded',
                data: {
                    imageUrl: me.options.videoGreet.animatedImageUrl
                }
            });
            me.isVideoGreetMax = false;
            me.isVideoGreet = true;
            showIt();
            preChatCloseMessagePopup(me);
        });
        // When Chat Session Ends, On very next message from Visitor, an overlay mask for starting new chat appears,
        // & visitor starts the chat at this point we need to delete few cookies for PreChat.
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnSendMessageFailure, cleanUp);
    }

    onParticipantsChanged(participants) {
        const me = this;
        ApexChat.localStorageAPI.Store('livechat_chat_participants', JSON.stringify(participants));
        ApexChat.preChatMsgTemplate = null;
        const image = me.DOM.getElementById('apexchat_prechat_chat_icon');
        // get old url for comparison
        const prevUrl = image.style.backgroundImage;
        for (let i = 0; i < participants.length; i++) {
            // change image if operator joins for the first time
            if (
                participants[i].userId > 0 &&
                prevUrl != participants[i].handlerImageUrl &&
                participants[i].handlerImageUrl
            ) {
                const imageUrl = AgentImageHandler(participants[i].handlerImageUrl);
                image.style.backgroundImage = `url('${imageUrl}')`;
            }
        }
    }

    applyCssClass(position) {
        // apply css classes base on pre chat position
        const me = this;
        // remove default classes
        removeClass(
            me.DOM.getElementById('apexchat_prechat_main_container'),
            'apexchat_prechat_theme_margin'
        );
        removeClass(
            me.DOM.getElementById('apexchat_prechat_message_popup'),
            'apexchat_prechat_tri_left'
        );
        removeClass(
            me.DOM.getElementById('apexchat_prechat_message_popup'),
            'apexchat_prechat_left_top'
        );
        removeClass(
            me.DOM.getElementById('apexchat_prechat_close_message_popup'),
            'apexchat_prechat_x_right'
        );
        removeClass(
            me.DOM.getElementById('apexchat_prechat_message_popup'),
            'apexchat_prechat_tri_left_theme'
        );
        addClass(
            me.DOM.getElementById('apexchat_prechat_close_message_popup'),
            'apexchat_prechat_x'
        );

        me.DOM.getElementById('apexchat_prechat_main_container').style.position = 'relative';
        me.DOM.getElementById('apexchat_prechat_main_bg').style.position = 'fixed';
        switch (position) {
            case Position.Left:
                me.templateRenderer.renderOnLeftPosition();
                break;
            case Position.Right:
                me.templateRenderer.renderOnRightPosition();
                break;
        }
    }
    showMessagePopupAndPublishAutoResize(config = { animate: true }) {
        const me = this;
        const PADDING = 15; // CHAT-5979 [V3] Pre-chat with default animation is cutting off shadow on top
        const ANIMATION_DELAY = 70;
        const RESIZE_CHECK_INTERVAL = 200;
        const MAX_WAIT_TIME = 3000;

        const ele = this.DOM.getElementById('apexchat_prechat_message_popup');
        if (!ele) return;

        const closeButtonEle = this.DOM.getElementById('close-btn-icon');
        if (config.animate) { // false when qt full text error arrived
            ele.classList.remove('fade-in');
            closeButtonEle.classList.remove('fade-in');
        }

        try {
            let timeout = 0;
            RunAsSoonAsWithDelay(() => {
                let calcCurrentMsgHeight = ele.scrollHeight;

                if (isMobile()) {
                    calcCurrentMsgHeight = this.calculateMobileHeight(ele);
                }

                this.postMessage({
                    event: 'prechat-auto-resizing',
                    data: {
                        currentMsgHeight: calcCurrentMsgHeight,
                        isSingleMsg: true,
                        messageBubble: ele,
                    }
                });
                if (config.animate) {
                    setTimeout(() => {
                        ele.style.opacity = 1;
                        ele.style.display = "block";
                        ele.style.top = `${PADDING}px`;
                        ele.classList.add('fade-in');
                        closeButtonEle.classList.add('fade-in');
                    }, ANIMATION_DELAY);
                }

                timeout += RESIZE_CHECK_INTERVAL;
            }, () => ele.scrollHeight > 52 || timeout > MAX_WAIT_TIME, RESIZE_CHECK_INTERVAL);
        } catch (error) {
            console.error("Prechat bubble size error:", error);
        }
    }

    calculateMobileHeight(ele) {
        const parent = document.getElementById('apexchat_prechat_invitation_wrapper');
        const bubble = this.DOM.getElementById('apexchat_prechat_main_bg');
        const offsetBottom = parseFloat(parent.style.marginBottom || 0);

        const availableHeight = window.innerHeight - offsetBottom - bubble.offsetHeight - 60;
        const calcHeight = ele.scrollHeight > availableHeight ? availableHeight : ele.scrollHeight;

        // Apply mobile-specific height constraints
        const hasGreetText = this.options.preChatHeaderTemplate?.trim()?.length > 0;
        let difference = 35;

        if (hasGreetText) {
            const greetEle = ele.querySelector('.livechat_prechat_plain_text_greet');
            difference += greetEle?.scrollHeight ?? 0;
        }

        const plainTextEle = ele.querySelector('.livechat_prechat_plain_text');
        if (plainTextEle) {
            plainTextEle.style.maxHeight = `${calcHeight - difference}px`;
            plainTextEle.style.overflow = 'auto';
        }

        ele.style.maxHeight = `${calcHeight}px`;

        return calcHeight;
    }
    async autoMessageRendering(options) {
        const me = this;
        const { message } = options;
        const { chatMsg } = options;
        const { index } = options;
        // as we are making Mock JSON for Pipe messaging, In case of Default Animation, we need to prevent the appending of content
        if (me.options.preChatMessageAnimation === PreChatMessageAnimation.Default) {
            if (message && message.messageType !== PreChatMessageType.plain_Text) {
                message.dontAppendExisitngContent = true;
                message.isFirstPreChatMessage = index === 0;
            }
            if (chatMsg && chatMsg.messageType !== PreChatMessageType.plain_Text) {
                chatMsg.dontAppendExisitngContent = true;
                chatMsg.isFirstPreChatMessage = index === 0;
            }
        }
        if (index == 0 && !ApexChat.prechatGreetingFlashed) {
            me.DOM.getElementById('apexchat_prechat_message').classList.add("livechat_prechat_first_message");
        }
        ApexChat.isFirstPreChatMessage = index === 0;
        // check message type is script message or plain message
        if (
            (index == -1 && chatMsg) ||
            (message &&
                message.messageType == PreChatMessageType.agent_Script &&
                message.agentScript)
        ) {
            const questionType = chatMsg ? chatMsg.questionType : message.questionType;
            me.messagePopupUI.render(chatMsg || message);
            me.messagePopupUI.clear();
            await me.renderScriptMessage(chatMsg || message.agentScript);
            me.messagePopupUI.questionTypeUIConfiguration(questionType);
        } else {
            // create model for message logging
            const messageLog = {};
            messageLog.visitorId =
                me.options.visitorId || getCookieValue('livechat_visitor_id') || 0;
            messageLog.visitorId |= 0;
            messageLog.text = message.message;
            messageLog.sourceType = SourceType.PreChat;
            await me.logMessageOnServer(messageLog);
            // render plain text message
            me.messagePopupUI.render(message);
        }
        me.showMessagePopupAndPublishAutoResize();
        // check message is prechat or chat flow
        if (
            !options.isPipedMessage &&
            message &&
            message.questionType == ScriptsQuestionType.None
        ) {
            const timeout = setTimeout(async () => {
                await me.queueNextMessage(index + 1, message.duration * 1000);
                clearTimeout(timeout);
            }, message.duration * 1000);
        }
        if (options.cb) {
            options.cb();
        }
    }

    async displayMessagePopup(index, isPreChatMessage, chatMsg) {
        const me = this;
        logIt('displayMessagePopup');
        const isMessage = chatMsg?.message || chatMsg?.text;
        if (me.isWindowedStarted()) {
            return; // no pop message if Windowed has started
        }
        // if chat started from prechat and chatmsg is undefined and isPreChatMessage true appears thats means its a prechat messages appearing so we dont need it to show because chat has already been started
        // Also, on windowed mode if chat started then we dont need to show popup while windowed mode is on.
        if (!chatMsg && me.isChatStartedFromPreChat && isPreChatMessage) {
            me.templateRenderer.hideTypingIndicator();
            return;
        }
        const isFromHistory = chatMsg && chatMsg.isFromHistory;
        const preChatMsg = me.options.preChat.preChatMessages[index];
        // CHAT-7226  Next Mapped Question Logic Change
        // as option property removed from backend now we explicity add option property to our msg.options object,
        // because all QT UI depend upon that property.
        if (
            preChatMsg &&
            preChatMsg.questionType != ScriptsQuestionType.None &&
            preChatMsg.agentScript &&
            preChatMsg.agentScript.options
        ) {
            preChatMsg.agentScript.options = addOptionProperty(
                preChatMsg.agentScript.options
            );
        }
        if (chatMsg && chatMsg.questionType != ScriptsQuestionType.None && !chatMsg.questionTypeDisplayListForVisitor && (chatMsg.questionType == ScriptsQuestionType.AllThatApply || chatMsg.questionType == ScriptsQuestionType.MultipleChoice)) {
            me.prechatBubbleScroll(chatMsg);
        } else {
            me.DOM.querySelector('.apexchat_prechat_talktext')?.classList?.remove('apexchat_prechat_message_qt');
        }
        // increase and display message counter
        // JIRA_4241 - in case of Last PreChatMessage no need to add counter!
        if (
            me.options.preChat.preChatMessages[index] &&
            !me.options.preChat.preChatMessages[index].isLastPreChatMessage &&
            !isFromHistory
        ) {
            const questionTypeId = ApexChat.storageAPI.Get('questionTypeId'); // check if question exists
            if (!isMessage && questionTypeId &&
                questionTypeId == me.options.preChat.preChatMessages[index].agentScriptAnswerId) {
                me.setMessageCounterCache(0);
            } else {
                me.setMessageCounterCache(1);
            }
        }
        me.messagePopupUI = me.templateRenderer.popupUI(me.options.isPreChatRoundedTheme);
        me.messagePopupUI.setMessageTemplate();
        me.displayMessageCounter();
        me.isPreChatMessage = isPreChatMessage;
        me.agentScriptAnswerId = 0;
        me.allowBackgroundClick = true;
        /// Wait for the flag/setting called “re-show after” which wipes the cookies after X amount of minutes and will treat them as a new visitor
        me.prechatStartedTimeout = window.setTimeout(() => {
            ApexChat.storageAPI.StoreTemp('livechat_prechat_started', false);
        }, me.options.reShowIntervalMinutes * 60 * 1000);
        // checking message type is prechat message or chat message
        if (isPreChatMessage && !me.isChatStartedFromPreChat) {
            // get prechat message
            var message = me.options.preChat.preChatMessages[index];
            if (message) {
                message.message = parseTemplate(
                    removeTextFollowedByColon(message.message),
                    me.options
                );
            }
            message.text = message.text || message.message;
            const msgObject = {
                m: message.agentScript || message
            };

            if (me.pipeMessageHandler.isValidPipedMessage(msgObject)) {
                me.hideMessageCounter(); // Hide counter in case of Pipe messages
                msgObject.isSplitMessage = true; // if message is piped define isSplitMessage to true
                // CHAT-7351- Split Message send as a one message on server.
                // in below logic we just send a pipe message as one message to server
                const messageLog = {};
                // create model for message logging
                messageLog.visitorId =
                    me.options.visitorId || getCookieValue('livechat_visitor_id') || 0;
                messageLog.text = removeTextFollowedByColon(msgObject.m.text);
                messageLog.scriptAnswerId = msgObject.m.id;
                messageLog.questionType = msgObject.m.questionType;
                messageLog.isNextQuestionMapped = msgObject.m.isNextQuestionMapped;
                messageLog.visitorResponseType = msgObject.m.visitorResponseType;
                messageLog.options = msgObject.m.options;
                messageLog.visitorResponseStatus = ScriptVisitorResponseStatus.UnAnswered;
                messageLog.questionTypeDisplayListForVisitor = msgObject.m.displayListForVisitor;
                messageLog.sourceType = SourceType.PreChat;
                messageLog.agentScriptDocuments = msgObject.m.isDocument && msgObject.m.agentScriptDocuments ? JSON.stringify(msgObject.m.agentScriptDocuments) : '';
                messageLog.isDocument = msgObject.m.isDocument;
                messageLog.isSmsTransfer = msgObject.m.isSmsTransfer || message.isSmsTransfer;
                await me.logMessageOnServer(messageLog); // logging message to server
                me.pipeMessageHandler.startPolling({
                    messageDisplayDuration:
                        message.duration > 100 ? message.duration : message.duration * 1000, // detecting either Its Seconds or Milliseconds
                    init() {
                        me.onTypingArrived({ indicator: true });
                    },
                    async startPollingCallback(m) {
                        m.message = m.text;
                        await me.autoMessageRendering({
                            chatMsg: m,
                            index: -1,
                            isPipedMessage: true
                        });
                        // In Piped messages the message can be QT we need QT to not to start chat IF user clicks on their DIV HTML Element
                        const shouldStartChat = m.questionType == ScriptsQuestionType.None;
                        me.bindPopupForStartingChat({
                            popupSelector: me.DOM.querySelector('.apexchat_prechat_message_bubble'),
                            shouldStartChat
                        });
                    },
                    async lastPollingCallback(args) {
                        me.onTypingArrived({ indicator: false });
                        const { m } = args;
                        m.message = m.text;
                        await me.autoMessageRendering({
                            chatMsg: m,
                            index: -1,
                            isPipedMessage: true,
                            cb: args.cb
                        });
                        // In Piped messages the last message can be QT we need QT to not to start chat IF user clicks on their DIV HTML Element
                        const shouldStartChat = m.questionType == ScriptsQuestionType.None;
                        me.bindPopupForStartingChat({
                            popupSelector: me.DOM.querySelector('.apexchat_prechat_message_bubble'),
                            shouldStartChat
                        });
                    }
                });
                return;
            } else {
                await me.autoMessageRendering({
                    message,
                    chatMsg,
                    index
                });
            }
            // checking chatroom msg is script message aur text message
        } else if (
            (chatMsg.scriptAnswerId > 0 || chatMsg.questionType == ScriptsQuestionType.AppointmentScheduler) &&
            // chatMsg.questionType != ScriptsQuestionType.None &&
            (!chatMsg.agentScriptDocuments && !chatMsg.isDocument
                ? chatMsg.questionType != ScriptsQuestionType.None
                : true) &&
            chatMsg.visitorResponseStatus == ScriptVisitorResponseStatus.UnAnswered
        ) {
            logIt(chatMsg);
            me.agentScriptAnswerId = -1;
            chatMsg.dontAppendExisitngContent = true; // we need detection here for QT is from Dashboard to handle animation.
            me.messagePopupUI.clear();
            me.messagePopupUI.render(chatMsg);
            await me.QTRendererExt.questionTypeRenderer.renderMessage(
                chatMsg,
                me.QTRendererExt.afterRenderMessage.bind2(me.QTRendererExt)
            );
            me.messagePopupUI.questionTypeUIConfiguration(chatMsg.questionType);
        } else {
            me.messagePopupUI.render(chatMsg);
        }
        // me.setAllowBackgroundClick();

        me.showMessagePopup(!me.options.isPreChatRoundedTheme, chatMsg || message);
    }

    prechatBubbleScroll(message) {
        const me = this;

        const isMCorATA = (
            message.questionType === ScriptsQuestionType.AllThatApply ||
            message.questionType === ScriptsQuestionType.MultipleChoice
        );
        if (isMCorATA && !message.displayListForVisitor) {
            let optionContainer = null;
            RunAsSoonAs(function () {
                const scrollHeight = optionContainer.scrollHeight;
                let scrolledHeight = 0;

                const scrollTrigger = me.DOM.querySelector('.apexchat_scroll_trigger');

                if (scrollTrigger) {
                    scrollTrigger.addEventListener('click', function () {
                        const scroll = optionContainer.clientHeight - 30;
                        scrolledHeight += scroll;

                        // Smooth scroll using requestAnimationFrame
                        optionContainer.scrollTo({
                            top: scrolledHeight,
                            behavior: 'smooth'
                        });

                        if ((scrolledHeight + scroll) > scrollHeight) {
                            this.style.display = 'none';
                        }
                    });
                    if (ApexChat.IsRoundedDynamicPlusTheme && optionContainer.clientHeight >= 160) {
                        scrollTrigger.style.display = 'flex';
                    } else if (!ApexChat.IsRoundedDynamicPlusTheme && optionContainer.clientHeight >= 150) {
                        scrollTrigger.style.display = 'flex';
                    } else {
                        scrollTrigger.style.display = 'none';
                    }
                }

                const scrollHandler = () => {
                    const scrollTop = optionContainer.scrollTop;
                    const clientHeight = optionContainer.clientHeight;
                    if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
                        if (scrollTrigger) scrollTrigger.style.display = 'none';
                        optionContainer.removeEventListener('scroll', scrollHandler);
                    }
                };

                optionContainer.addEventListener('scroll', scrollHandler);

            }, function () {
                optionContainer = me.DOM.querySelector('.apexchat_prechat_scrolled_options .apexchat_question_type_styled_input_container');
                return optionContainer && window.getComputedStyle(optionContainer).display !== 'none';
            });

            const talkText = me.DOM.querySelector('.apexchat_prechat_talktext');
            if (talkText) {
                talkText.classList.add('apexchat_prechat_message_qt');
            }
        }
    }


    endChat(m) {
        const me = this;
        me.resetMessageCounterCache();
    }

    async queueAutoMessaging() {
        const me = this;
        if (me.options.preChat.preChatMessages.length > 0) {
            let lastPreChatPopoutMessage = me.getLastMessageCache();
            if (!lastPreChatPopoutMessage) {
                // It means the next message is first to be display
                lastPreChatPopoutMessage = {
                    index: 0,
                    duration: me.options.preChat.preChatFirstMessageTimeout
                        ? 1000 * me.options.preChat.preChatFirstMessageTimeout
                        : 1000
                };
            } else {
                me.setMessageCounterCache(-1);
            }
            // set online agent always
            const roundedMessagePopup = me.DOM.getElementsByClassName('apexchat_prechat_message_bubble');
            // .$(me.DOM.getElementById('apexchat_prechat_message_popup_container'))
            // .find('.apexchat_prechat_message_bubble');
            if (roundedMessagePopup.length > 0) {
                me.templateRenderer.renderer.showOnlineAgentTag();
            }
            // CHAT-6794 [PreChat] - Mapped Question on Page Refresh not appearing
            // summary: if mapped question has appeared, in case of refresh it should appear again instead of parent question
            const hasMappedQuestionAppeared = storageAPIExists(
                TempCache.APEXCHAT_PRECHAT_MAPPED_QUESTION_COOKIE
            );
            let lastMappedQuestion;
            if (hasMappedQuestionAppeared) {
                lastMappedQuestion = JSON.parse(
                    getStorageAPIValue(TempCache.APEXCHAT_PRECHAT_MAPPED_QUESTION_COOKIE)
                );
            }
            await me.queueNextMessage(
                lastPreChatPopoutMessage.index,
                lastPreChatPopoutMessage.duration,
                lastMappedQuestion
            );
        }
    }

    async queueNextMessage(index, duration, lastMappedQuestion) {
        // show next message if available
        const me = this;
        if (me.options.preChat.preChatMessages.length == index) {
            return;
        }
        if (index < 0) {
            // Do not show the next message if somebody close the message and then refresh the page
            // In message close event we are setting the index of the last message = -1
            return;
        }
        me.postMessage({ event: 'new-pre-chat-message-arriving' });
        if (me.options.preChat.preChatMessages.length > index) {
            // CHAT-6794 [PreChat] - Mapped Question on Page Refresh not appearing
            // summary: Once a mapped question appears and the visitor decides to refresh the page, rather than the parent question appearing, the visitor will now see the mapped question.
            // lastMappedQuestion: Its only for Predefined messages.
            // it will be always 'NULL' in case of running Chat session,
            // It could be 'Object' only if the last prechat msg was not Parent Question.
            //me.messageTimeout = window.setTimeout(() => {
            await me.displayMessagePopup(index, true, lastMappedQuestion, duration);
            // }, duration);
        }
        // summary: isPlainText is the plain text when user adds plain text from edit profile not agent scripted plain text.
        const isPlainText =
            me.options.preChat.preChatMessages[index - 1] &&
            me.options.preChat.preChatMessages[index - 1].messageType ==
            PreChatMessageType.plain_Text;
        // isAgentScript means its agent script.
        const isAgentScript =
            me.options.preChat.preChatMessages[index - 1] &&
            me.options.preChat.preChatMessages[index - 1].messageType ==
            PreChatMessageType.agent_Script;
        // isQuestionType and None means Plain Text.
        const isQTNone =
            me.options.preChat.preChatMessages[index - 1] &&
            me.options.preChat.preChatMessages[index - 1].questionType ==
            ScriptsQuestionType.None;
        // JIRA_4241 - Checking that Prechat message is Last, Plain Text and prevent multi-rendering.
        if (
            me.options.preChat.preChatMessages.length == index && // To Make sure Last PreChat Msg
            (isPlainText || (isAgentScript && isQTNone)) &&
            !me.options.preChat.preChatMessages[index - 1].isLastPreChatMessage
        ) {
            // prevent multi-rendering
            me.options.preChat.preChatMessages[index - 1].isLastPreChatMessage = true;
            //me.messageTimeout = window.setTimeout(() => {
            await me.displayMessagePopup(index - 1, true);
            me.showMessagePopupAndPublishAutoResize()
            //}, duration);
            return;
        }
        me.setLastMessageCache(index, duration);
    }

    bindPopupForStartingChat(options) {
        const me = this;
        const { popupSelector } = options;
        const { message } = options;
        var popupSelectorElement = popupSelector;
        if (popupSelectorElement) {
            popupSelectorElement.setAttribute('data-should-start-chat', options.shouldStartChat);
            //me.$(popupSelector, me.DOM).data('shouldStartChat', options.shouldStartChat);
            popupSelectorElement.addEventListener('click', function (e) {
                // if (e.target.matches('.startchat')) {
                me.startChatFromPreChat(e, {
                    srcElement: this,
                    message
                });
                //}
            });
            me.handleADA(
                popupSelectorElement,
                me.startChatFromPreChat.bind2(this, {
                    srcElement: popupSelectorElement,
                    message
                })
            );
        }

    }

    // As we have Rounded Prechat Theme, so the old prechat theme we are calling Classical PreChat
    showMessagePopup(isPreChatForClassicalTheme, message) {
        if (!message?.message) return
        // Default OR Classical
        const me = this;
        // we need different popupSelector for both Classical and Rounded Theme
        const popupSelector = isPreChatForClassicalTheme
            ? '#apexchat_prechat_message_popup'
            : '.apexchat_prechat_message_bubble';
        // if question type is none then it return true and store in data attribute
        const isQTText =
            (message && message.questionType === ScriptsQuestionType.None) ||
            message.questionType === ScriptsQuestionType.Time ||
            message.questionType === ScriptsQuestionType.TimeCalendar ||
            message.questionType === ScriptsQuestionType.CalendarDate;
        const popupMessageElement = me.DOM.querySelector(popupSelector);
        popupMessageElement.setAttribute('data-should-start-chat', isQTText);
        me.setAllowBackgroundClick(message.questionType)
        if (me.allowBackgroundClick) {
            me.bindPopupForStartingChat({
                shouldStartChat: isQTText,
                popupSelector: popupMessageElement,
                message
            });
        } else {
            // var clonedElement = popupMessageElement.cloneNode(true);
            // popupMessageElement.parentNode.replaceChild(clonedElement, popupMessageElement);
            //me.$(popupSelector, me.DOM).unbind('click');
        }
        // me.DOM.getElementById('apexchat_prechat_typing_div').style.display = 'none';
        me.DOM.getElementById('apexchat_prechat_main_container').style.width = `${me.iconWidth + 265
            }px`;
        // update UI object
        const el = me.DOM.getElementById('apexchat_prechat_message_popup');
        const position = me.options.preChat.preChatPosition;
        el.style.display = 'inline-block';
        me.templateRenderer.animateMessagePopup(el, position);
        // el.style.width = messagePopupWidth;
        me.DOM.getElementById('apexchat_prechat_message_div').style.display = 'block';
        // me.DOM.getElementById('apexchat_prechat_typing_div').style.display = 'none';
        // resize iframe
        me.postMessage({
            event: 'prechat-size',
            data: {
                width: me.iconWidth + me.templateRenderer.widgetWidth,
                height: me.iconHeight > el.offsetHeight ? me.iconHeight + 10 : el.offsetHeight + 20,
                addValue: me.templateRenderer.heightPosition
            }
        });
        me.templateRenderer.hideTypingIndicator();

    }

    async renderScriptMessage(message) {
        const me = this;
        logIt('renderScriptMessage' + message.text)
        me.options.preChat.language = me.options.language || 'eng';
        const messageLog = {};
        message.text = removeTextFollowedByColon(message.text);
        me.agentScriptAnswerId = message.id;
        // create model for message logging
        messageLog.visitorId =
            me.options.visitorId || getCookieValue('livechat_visitor_id') || 0;
        messageLog.text = message.text;
        messageLog.scriptAnswerId = message.id;
        messageLog.questionType = message.questionType;
        messageLog.isNextQuestionMapped = message.isNextQuestionMapped;
        messageLog.options = message.options;
        messageLog.agentScriptDocuments = message.isDocument && message.agentScriptDocuments ? JSON.stringify(message.agentScriptDocuments) : '';
        messageLog.isDocument = message.isDocument;
        messageLog.visitorResponseStatus = ScriptVisitorResponseStatus.UnAnswered;
        messageLog.visitorResponseType = message.visitorResponseType;
        messageLog.questionTypeDisplayListForVisitor = message.displayListForVisitor;
        messageLog.isSplitMessage = message.isSplitMessage;
        messageLog.sourceType = SourceType.PreChat;
        messageLog.isSmsTransfer = message.isSmsTransfer;
        await me.logMessageOnServer(messageLog);
        if (message.questionType == ScriptsQuestionType.FullText) {
            message.userId = message.userId || 0;
            message.participantDisplayName = message.participantDisplayName || '';
            message.createdOn = new Date();
            await me.QTRendererExt.questionTypeRenderer.renderMessage(
                message,
                me.QTRendererExt.afterRenderMessage.bind2(me.QTRendererExt)
            );
            const questionWrapper = me.DOM.querySelector('.livechat_prechat_full_text_greet');
            appendGreeting(questionWrapper, me.options);
        } else if (message.questionType == ScriptsQuestionType.None && !message.agentScriptDocuments && message.text) {
            // me.DOM.getElementById('apexchat_prechat_message').innerHTML = message.text;
            me.DOM.getElementById('apexchat_prechat_message').innerHTML = preChatPlainTextTemplate({
                text: message.text,
                hidden: false
            });
            const questionWrapper = me.DOM.querySelector('.livechat_prechat_plain_text_greet');
            appendGreeting(questionWrapper, me.options);
            me.DOM.getElementById('apexchat_prechat_message_popup_container').classList.add('livechat_prechat_message_show');

        } else {
            // render agent script message
            me.prechatBubbleScroll(message);
            me.DOM.getElementById('apexchat_prechat_message').innerHTML = '';
            message.userId = message.userId || 0;
            message.participantDisplayName = message.participantDisplayName || '';
            message.createdOn = new Date();
            message.questionTypeDisplayListForVisitor = message.displayListForVisitor;
            await me.QTRendererExt.questionTypeRenderer.renderMessage(message);
            me.questionTypeUIConfiguration();
        }
        // here, we make sure we grab the messages which have been shown
        // while prechat is displayed/not hidden
        const m = message;
        const currentPreChatState = me.getCurrentState();
        m.isShown = currentPreChatState === WidgetStates.ShownMaximized;
        ApexChat.prechatMessagesDisplayed = ApexChat.prechatMessagesDisplayed || [];
        if (m.isShown) {
            ApexChat.prechatMessagesDisplayed.push(m);
        }
    }

    setAllowBackgroundClick(questionType) {
        const me = this;
        if (
            questionType >= 0 &&
            questionType != ScriptsQuestionType.None &&
            questionType != ScriptsQuestionType.Text &&
            questionType != ScriptsQuestionType.Time &&
            questionType != ScriptsQuestionType.TimeCalendar &&
            questionType != ScriptsQuestionType.CalendarDate
        ) {
            me.allowBackgroundClick = false;
        }
    }

    questionTypeUIConfiguration(questionType) {
        const me = this;
        me.setAllowBackgroundClick(questionType);
        //TODO
        // ADACompliant.push(me.$('.apexchat_ada_compliance', me.DOM)).apply();
        me.DOM.querySelector('.apexchat_question_type_close_button')?.style.setProperty('display', 'none', 'important');
        me.DOM.querySelector('#apexchat_click_instruction')?.style.setProperty('display', 'none', 'important');
        me.DOM.querySelector('#apexchat_participant_display_name')?.style.setProperty('display', 'none', 'important');
        me.DOM.querySelector('#apexchat_participant_display_col')?.style.setProperty('display', 'none', 'important');
        const questionWrapper = me.DOM.querySelector('.livechat_question_text');
        appendGreeting(questionWrapper, me.options);
    }


    async logMessageOnServer(log) {
        const me = this;
        if (me.options.videoGreetEnabled) {
            return;
        }
        if (localstorageAPIExists('livechat_prechat_msg_array')) {
            me.messageArray = JSON.parse(localStorageAPIGet('livechat_prechat_msg_array'));
        }
        if (log.isSplitMessage) {
            // if message is splitted message then we dont need to log on server because we already did it
            return;
        }
        const preChatMsgObj = me.getDuplicatedObjectFromArray(me.messageArray, log.text, 'text');
        if (preChatMsgObj) {
            me.preChatMessageId = preChatMsgObj.id;
            return; // duplicated message.
        }
        const url = `${GlobalVariables.ApexChatBaseUrl}api/prechat/messages`;
        // encode just in case there are any HTML tags to avoid request failure due to CSRF
        const encodedLog = encodeHTML(JSON.stringify(log));
        const response = await fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            method: "POST",
            body: encodedLog
        })
        const res = await response.json();
        me.preChatMessageId = res.id;
        me.messageArray.push({
            id: me.preChatMessageId,
            text: log.text
        });
        ApexChat.localStorageAPI.Store(
            'livechat_prechat_msg_array',
            JSON.stringify(me.messageArray)
        );
        me.setPreChatMessageIdsCache(me.preChatMessageId);
    }

    getDuplicatedObjectFromArray(array, msg, property) {
        let i = array.length;
        while (i--) {
            if (array[i][property] === msg) {
                return array[i];
            }
        }
        return null;
    }

    setLastMessageCache(index, duration) {
        const me = this;
        const message = { index, duration };
        Cookies.set(me.lastMessageStoreName, JSON.stringify(message));
    }

    getLastMessageCache() {
        const me = this;
        const message = Cookies.get(me.lastMessageStoreName);
        return message ? JSON.parse(message) : null;
    }

    /**
     * Set the message counter
     * @param {value} counter value
     */
    setMessageCounterCache(value) {
        const me = this;
        const oldValue = me.getMessageCounterCache();
        let newValue = oldValue + value;
        if (newValue < 0) {
            newValue = 0;
        }
        Cookies.set(me.messageCounterStoreName, newValue);
    }

    getMessageCounterCache() {
        const me = this;
        const counter = Cookies.get(me.messageCounterStoreName) || 0;
        return parseInt(counter);
    }

    resetMessageCounterCache() {
        const me = this;
        Cookies.del(me.messageCounterStoreName);
    }

    setPreChatMessageCache(message) {
        // store pre chat message data in local storage
        const storeName = 'livechat_prechat_messages';
        const storeData = Cookies.get(storeName);
        let storeJson = JSON.parse(storeData);
        if (!storeJson) {
            storeJson = [];
        }
        storeJson.push(message);
        Cookies.set(storeName, JSON.stringify(storeJson));
    }

    setPreChatMessageIdsCache(id) {
        // store pre chat message data in local storage
        const storeData = getCookieValue(TempCache.APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE);
        if (storeData) {
            var storeJson = JSON.parse(storeData);
        }
        if (!storeJson) {
            storeJson = [];
        }
        storeJson.push(id);
        Cookies.set(
            TempCache.APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE,
            stringify(storeJson)
        );
    }

    displayMessageCounter() {
        const me = this;
        const messageCounter = me.getMessageCounterCache();
        me.templateRenderer.displayMessageCounter(messageCounter);
    }

    hideMessageCounter() {
        const me = this;
        me.templateRenderer.hideMessageCounter();
        me.templateRenderer.hideTalkBubbleIcon();
    }

    show() {
        const me = this;
        // check video greet maximize
        // Do not show prechat if exitpopup is shown
        if (me.state.getStateValue(WidgetTypes.ExitPopup) !== WidgetStates.ShownMaximized) {
            super.show();
            this.maximize();
        }
        me.isVideoGreetMax = false;
        // we dont need anymore to show last message from history because now we use delay on MessageArrived
        // this.displayLastMessageFromHistory(); //when preChat widget appear after dom minimize,show last message on popup from cookie
    }

    // CHAT-7300 - Message not appearing when minimizing the preChat
    // To Display Last Message from chat history
    // async displayLastMessageFromHistory() {
    //     const me = this;
    //     const lastMessage = ApexChat.TryParse(Cookies.get('livechat_chat_lastmessage')); // get last message of chat from cookies
    //     if (
    //         lastMessage &&
    //         lastMessage.questionType !== ScriptsQuestionType.None &&
    //         (!me.lastMessageDisplayed ||
    //             (me.lastMessageDisplayed && me.lastMessageDisplayed.id != lastMessage.id))
    //     ) {
    //         // check if message is question type and message is not appear before so show it
    //         if (lastMessage.text.indexOf('||') > -1) {
    //             // we are not handling pipe message here, as this is perfectly render by onMessageArrived
    //             return;
    //         }
    //         if (lastMessage.options) {
    //             lastMessage.options = addOptionProperty(lastMessage.options);
    //         }
    //         me.lastMessageDisplayed = lastMessage;
    //         me.templateRenderer.showTypingIndicator();
    //         //window.setTimeout(() => {
    //         await me.displayMessagePopup(0, false, lastMessage);
    //         //}, lastMessage.questionTypeDelaySeconds * 1000);
    //     }
    // }

    hide() {
        super.hide();
        // resize iframe
        this.postMessage(
            {
                event: WidgetTypes.PreChat + WidgetStates.Hidden,
                data: {}
            },
            '*'
        );
        window.clearTimeout(this.messageTimeout);
        this.pipeMessageHandler.reset(); // stop all processing of pipe messages if its running
        // reset message counter
        this.resetMessageCounterCache();
        this.templateRenderer.hideMessagePopup();
    }

    maximize() {
        super.maximize();
    }

    onMessageArrived(m, initialLoad, index) {

        const me = this;
        m.isFromHistory = initialLoad;
        // CHAT-7226  Next Mapped Question Logic Change
        // as option property removed from backend now we explicity add option property to our msg.options object,
        // because all QT UI depend upon that property.
        if (m.questionType != ScriptsQuestionType.None && m.options) {
            m.options = addOptionProperty(m.options);
        }
        // summary: If msg is from History & the previous message was CLOSED by user no need to show it again on Page Refresh.
        const isPreviousMessageClosed =
            m.isFromHistory && !me.getMessageCounterCache() && me.isPageRefreshed();
        // System messages always less than 0 & when visitor sends message visitor userId always 0
        // For preChat messages we dont need to return,in CHAT-7300 all preChat message and all mapped questions associated with it has preChat userId
        // CHAT-7325 Poke Message should not return
        // Stop showing "The visitor has returned to the chat" message
        if (
            (m.userId <= 0 &&
                !me.isPreChatMessage &&
                m.userId !== ParticipantIds.prechat &&
                m.userId !== ParticipantIds.pokeMessage) ||
            isPreviousMessageClosed ||
            m.shouldShowChatEndedMessage ||
            m.userId === ParticipantIds.bot || // "All visitors have left the chat" message
            m.userId === ParticipantIds.nonVisitorSystem // shelve chat message
        ) {
            // Avoid showing system/visitor messages
            return false;
        }
        // 0.001 second PIPE_QUESTION_TYPE_DELAY_SECOND is no more needed..commenting it for now.
        // if (m.questionTypeDelay === ApexChat.PIPE_QUESTION_TYPE_DELAY_SECOND) { //for pipe message we have mentioned 0.001 second but we need that only for DOM for prechat we define 3 seconds
        //    m.questionTypeDelay = me.options.questionTypeDelay * 1000; // set delay as per profile settings
        // }
        if (
            me.state.getStateValue(WidgetTypes.DOM) === WidgetStates.ShownMinimized ||
            me.state.getStateValue(WidgetTypes.ExitPopup) === WidgetStates.Closed
        ) {
            // todo close/hide event
            if (m.isChatEnded) {
                me.endChat(m);
            } else {
                if (m.questionType === ScriptsQuestionType.VideoGreet) {
                    return;
                }
                m.isFromPreChat = true;
                me.displayMessagePopup(0, false, m);
                // do not show the prechat message in windowed mode
                if (!me.isWindowedStarted() && (m?.message || m?.text)) {
                    me.showMessagePopupAndPublishAutoResize();
                }
                // TODO:The below code is not needed for now commenting let QA test then I'll remove this. (Mahad)
                // m.isLastSplitMessage: No typing indicator and delay required.
                // if (m.isLastSplitMessage || !me.options.questionTypeDelay) {
                //    me.displayMessagePopup(0, false, m);
                // } else {
                //    me.templateRenderer.showTypingIndicator();
                //    window.setTimeout(function () {
                //        me.displayMessagePopup(0, false, m);
                //    }, me.options.questionTypeDelay * 1000);
                // }
            }
        }
    }

    onTypingArrived(args, self) {
        const me = this;
        // if (me.state.getStateValue(WidgetTypes.DOM) == WidgetStates.ShownMinimized) { // todo close/hide event
        if (args.indicator) {
            // me.DOM.getElementById('apexchat_prechat_typing_div').style.display = 'block';
            me.templateRenderer.showTypingIndicator();
            // me.templateRenderer.displayMessageCounter();
        } else {
            // me.DOM.getElementById('apexchat_prechat_typing_div').style.display = 'none';
            me.templateRenderer.hideTypingIndicator();
        }
        // }
    }
}
